import { BaseModel } from './BaseModel';
import Learner from './Learner';
import LearningUnit from './LearningUnit';
import CredentialLink from './CredentialLink';

export class Credential extends BaseModel {
  static get entity() {
    return 'credentials';
  }

  static get fk() {
    return 'credential_id';
  }

  static fields() {
    return {
      id: this.attr(null),
      accredible_credential_id: this.attr(null),
      accredible_credential: this.attr(null),
      user_id: this.attr(null),
      user: this.belongsTo(Learner, 'user_id'),
      learning_unit_id: this.attr(null),
      learning_unit: this.belongsTo(LearningUnit, 'learning_unit_id'),
      seen_at: this.attr(null),
      credential_link_ids: this.attr(null),
      credential_link: this.hasManyBy(CredentialLink, 'credential_link_ids'),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      delete_at: this.attr(null)
    };
  }

  static apiConfig = {
    actions: {
      async fetch(learningUnitId, userId) {
        try {
          const result = await this.get(
            `/learning-unit/${learningUnitId}/user/${userId}/credential`
          );
          return result;
        } catch (error) {
          return null;
        }
      },
      async fetchCredentialDetail(learningUnitId, userId) {
        try {
          const result = await this.get(
            `/learning-unit/${learningUnitId}/user/${userId}/credential`,
            { save: false }
          );
          return result;
        } catch (error) {
          return null;
        }
      },

      fetchByLearner() {
        return this.get(`/credentials/learner`);
      },

      update(credentialId) {
        console.log('updating credential ', credentialId);
        return this.put(`credentials/${credentialId}`, { seen_at: Date.now() });
      },

      /**
       * @param {Object} body
       * @param {Number} learning_unit
       * @param {Number} section
       * @param {Number} user
       * @returns {Object} credential
       */
      createWithAccredible(body) {
        return this.post(`/credentials/accredible`, body);
      }
    }
  };
}

export default Credential;
